module.exports = __webpack_public_path__ + "media/images/icons/plus_green-0cf290876c3285667a1e4116d89c1fe1.svg";